import { IconProps } from "Icons/types";

import { uiGray } from "constants/colors";

export const Lock01Icon = ({
  width = 16,
  height = 16,
  stroke = uiGray[80],
  strokeWidth = 1.2,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="lock-01-icon"
  >
    <path
      d="M11.3333 6.66667V5.33333C11.3333 3.49238 9.84094 2 7.99999 2C6.15904 2 4.66666 3.49238 4.66666 5.33333V6.66667M7.99999 9.66667V11M5.86666 14H10.1333C11.2534 14 11.8135 14 12.2413 13.782C12.6176 13.5903 12.9236 13.2843 13.1153 12.908C13.3333 12.4802 13.3333 11.9201 13.3333 10.8V9.86667C13.3333 8.74656 13.3333 8.18651 13.1153 7.75869C12.9236 7.38236 12.6176 7.0764 12.2413 6.88465C11.8135 6.66667 11.2534 6.66667 10.1333 6.66667H5.86666C4.74655 6.66667 4.1865 6.66667 3.75868 6.88465C3.38235 7.0764 3.07639 7.38236 2.88464 7.75869C2.66666 8.18651 2.66666 8.74656 2.66666 9.86667V10.8C2.66666 11.9201 2.66666 12.4802 2.88464 12.908C3.07639 13.2843 3.38235 13.5903 3.75868 13.782C4.1865 14 4.74655 14 5.86666 14Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
